const fpVideo = (function(){
	/** Private **/
	const the_video = document.querySelector('#fp_video');

	function playVideoWhenReadyAndDisplayed() {
		if (window.getComputedStyle(the_video) !== 'none') {
			if (the_video.readyState === 4) {
				the_video.play();
			}
			else {
				setTimeout(function () {
					playVideoWhenReadyAndDisplayed(the_video);
				}, 100)
			}
		}
	}

	/** Public **/
	function setup(){
		// Play video when ready
		playVideoWhenReadyAndDisplayed();

		window.addEventListener('resize',playVideoWhenReadyAndDisplayed)
	}

	return setup;
})();